module.exports = __webpack_public_path__ + "static/media/ic_mapfre.6828b92a.png";